import { render, staticRenderFns } from "./UserSearchActivity.vue?vue&type=template&id=b38e9f06&scoped=true"
import script from "./UserSearchActivity.vue?vue&type=script&lang=js"
export * from "./UserSearchActivity.vue?vue&type=script&lang=js"
import style0 from "./UserSearchActivity.vue?vue&type=style&index=0&id=b38e9f06&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b38e9f06",
  null
  
)

export default component.exports